import React from 'react';
import PropTypes from 'prop-types';
import { FaCheckCircle, FaFileAlt } from 'react-icons/fa'; // Importing icons from React Icons
import './ActsAndRulesSection.css';

export default function ActsAndRulesSection({ title, subtitle, acts, explanation }) {
  return (
    <section className="acts-and-rules-section_ac44">
      <h1 className="section-title_ac44">{title}</h1>
      <h2 className="section-subtitle_ac44">{subtitle}</h2> {/* Added subtitle */}
      
      <div className="acts-list_ac44">
        {acts.map((act, index) => (
          <div key={index} className="act-item_ac44">
            <FaCheckCircle className="act-item-icon" /> {/* Icon added */}
            <h3 className="act-title_ac44">{act}</h3>
          </div>
        ))}
      </div>
      
      <div className="explanation_ac44">
        <FaFileAlt className="explanation-icon" /> {/* Icon added */}
        <p>{explanation}</p>
      </div>
    </section>
  );
}

ActsAndRulesSection.propTypes = {
  title: PropTypes.string.isRequired,
  subtitle: PropTypes.string.isRequired,  // Added subtitle to prop types
  acts: PropTypes.arrayOf(PropTypes.string).isRequired,
  explanation: PropTypes.string.isRequired,
};
